import safeLocalStorage from 'safe-localstorage';

export function fittingTo(state, bounds) {
  state.fittingTo = bounds;
}

export function lockToIdealBounds(state, lock = true) {
  state.lockToIdealBounds = lock;
}

export function mapStyle(state, style) {
  state.mapStyle = style;
  safeLocalStorage.set('map/mapStyle', style);
}

export function matchesIdealBounds(state, matches = true) {
  state.matchesIdealBounds = matches;
}

export function reserveOnLoadFocus(state, id) {
  state.reservingOnLoadFocus = id;
}

export function setSelectedDrawerShouldUpdate(state, shouldUpdate) {
  state.selectedDrawerShouldUpdate = shouldUpdate;
}

export function setClusterableAssetsGeoJson(state, featuresByKey) {
  state.clusterableAssetsGeoJson = Object.freeze({ ...featuresByKey });
}

export function setClusteredBounds(state, clusteredBounds) {
  state.clusteredBounds = clusteredBounds;
}

export function setClusterEnabled(state, clusters) {
  state.clusterAssets = clusters;
  safeLocalStorage.set('map/clusterAssets', clusters);
}

export function setContextualMenuOpen(state, isOpen) {
  state.contextualMenuOpen = isOpen;
}

export function setExternalAddressDisplay(state, display) {
  state.displayExternalAddress = display;
}

export function setIdealBounds(state, idealBounds) {
  state.idealBounds = idealBounds;
}

export function setInViewportFencesHash(state, hash) {
  state.inViewportFencesHash = hash;
}

export function setLegendOpened(state, isOpen) {
  state.legendOpened = isOpen;
  safeLocalStorage.set('map/legendOpened', isOpen);
}

export function setListDialogOpen(state, isOpen) {
  state.listDialogOpen = isOpen;
}

export function setPendingFitToIdeal(state, pendingFitToIdeal) {
  state.pendingFitToIdeal = pendingFitToIdeal;
}

export function setSelectedAssetGeoJson(state, featuresByKey) {
  state.selectedAssetGeoJson = Object.freeze({ ...featuresByKey });
}

export function setShowDriverNameInList(state, show) {
  safeLocalStorage.set('map/showDriverNameInList', show);
  state.showDriverNameInList = show;
}

export function setShowNicknameInList(state, show) {
  safeLocalStorage.set('map/showNicknameInList', show);
  state.showNicknameInList = show;
}

export function setShowAddressInList(state, show) {
  safeLocalStorage.set('map/showAddressInList', show);
  state.showAddressInList = show;
}

export function setNearbyMapStyle(state, style) {
  state.nearbyMapStyle = style;
  safeLocalStorage.set('map/nearbyMapStyle', style);
}

export function setNearbyVehiclesFiltered(state, isFiltered) {
  state.nearbyVehiclesFiltered = isFiltered;
}

export function setTripsMapStyle(state, style) {
  state.tripsMapStyle = style;
  safeLocalStorage.set('map/tripsMapStyle', style);
}

export function setTripsShowPlaces(state, show) {
  state.tripsMapShowPlaces = show;
  safeLocalStorage.set('map/tripsMapShowPlaces', show);
}

export function setZoomLevel(state, zoomLevel) {
  state.zoomLevel = zoomLevel;
}

export function showAddPlace(state, show) {
  state.showAddPlace = show;
}

export function showPlaces(state, show) {
  state.showPlaces = show;
  safeLocalStorage.set('map/showPlaces', show);
}

export function showTagColors(state, show) {
  state.showTagColors = show;
  safeLocalStorage.set('map/showTagColors', show);
}

export function showTraffic(state, show) {
  state.showTraffic = show;
  safeLocalStorage.set('map/showTraffic', show);
}

export function updateInProgress(state, inProgress) {
  state.updateInProgress = inProgress;
}

export function setAssetRecentMapStyle(state, style) {
  state.assetRecentMapStyle = style;
  safeLocalStorage.set('map/assetRecentMapStyle', style);
}

export function setLiveMapInitialized(state, initialized) {
  state.liveMapInitialized = initialized;
}
